import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
  Col
} from 'react-bootstrap'
import { get, toNumber } from 'lodash'
import CalcSection from './CalcSection'
import CalcParagraph from './CalcParagraph'
import NavBtn from './NavBtn'
import NavBar from './NavBar'
import { updateHelpLevel } from '../../redux/app-reducer'

/**
 * Basic component for rendering Section 1 of the calculator
 */
class Section0 extends Component {
  /**
   * C'tor
   * @param props
   */
  constructor (props) {
    super(props)

    this.onRadioClick = this.onRadioClick.bind(this)
  }

  /**
   * Handle radio button click
   * @param {*} event
   */
  onRadioClick (event) {
    const val = get(event, 'target.value')
    if (val) {
      this.props.dispatch(updateHelpLevel(val))
    }
  }

  /**
   *
   */
  render () {
    const btnGroupStyle = {
      paddingTop: '30px',
      textAlign: 'center'
    }

    return (
      <CalcSection
        sectionProgress={this.props.sectionProgress}
        title={this.props.title}
      >
        <CalcParagraph>
          What is your retirement planning expertise?
        </CalcParagraph>
        <Col xs={0} sm={1} lgHidden />
        <Col xs={12} sm={7}>
          <ButtonToolbar style={btnGroupStyle}>
            <ToggleButtonGroup
              type='radio'
              name='options'
              defaultValue={toNumber(this.props.helpLevel)}
              onClick={this.onRadioClick}
              vertical
            >
              <ToggleButton value={1}>
                Beginner, could use lots of help
              </ToggleButton>
              <ToggleButton value={2}>Intermediate, some help</ToggleButton>
              <ToggleButton value={3}>Pro, don't need help</ToggleButton>
            </ToggleButtonGroup>
          </ButtonToolbar>
        </Col>

        <NavBar>
          <NavBtn nextSection={1} />
        </NavBar>
      </CalcSection>
    )
  }
}

CalcSection.propTypes = {
  title: PropTypes.string.isRequired
}

export function mapStateToProps (state) {
  return {
    helpLevel: state.get('app').get('helpLevel')
  }
}

export default connect(mapStateToProps)(Section0)



// WEBPACK FOOTER //
// ./src/components/sections/Section0HelpLevel.js